var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{staticClass:"drag-handle",staticStyle:{"cursor":"move"},attrs:{"title":_vm.trans('general.dragAndDropReorderTitle')}},[_vm._v("mdi-drag")])}
var staticRenderFns = []

export { render, staticRenderFns }